import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Divider } from '@mui/material';

import { useSidebarData } from '../../../hooks/useSidebarData';
import IsGranted from '../../../components/is-granted/IsGranted';
import NavigationItem from './NavigationItem';

import scss from './MobileNavigation.module.scss';

function MobileNavigation({ onCloseMenu }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const sidebarData = useSidebarData();

  const handleNavigate = (path) => {
    navigate(path);

    onCloseMenu();
  };

  return (
    <nav>
      <ul className={scss.menuList}>
        {sidebarData.map(({ label, icon, url, isStrokeIcon, selectedRoutes, permissions, disabled }) => (
          <IsGranted key={label} permissions={permissions}>
            <NavigationItem
              label={label}
              icon={icon}
              url={url}
              pathname={pathname}
              isStrokeIcon={isStrokeIcon}
              selectedRoutes={selectedRoutes}
              disabled={disabled}
              onNavigate={handleNavigate}
            />
          </IsGranted>
        ))}
      </ul>

      <Divider />
    </nav>
  );
}

export default MobileNavigation;
